// extracted by mini-css-extract-plugin
module.exports = {"cont-partners":"cont-partners","contPartners":"cont-partners"};